import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_ALMACENAJE } from '../../../../config/tables'

function TotalAlmacenajeView () {
  return (
    <MuiTable id={TABLA_TOTAL_ALMACENAJE} />

  )
}

export default TotalAlmacenajeView
